import { OptionTitle } from "./OptionTitle"

export const GenderIdentityChoices: Array<OptionTitle> = [
  { title: "Man", id: "MAN" },
  { title: "Woman", id: "WOMAN" },
  { title: "Non-binary", id: "NON_BINARY" },
  { title: "Another", id: "ANOTHER_GENDER_IDENTITY" }
]
